export const FCT_SCENARIOS = {
  arable_3yr_baseline: {
    id: 'arable_3yr_baseline',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 8.14,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 2.17,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 2.17,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 18.9,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00018',
          quantity: 13.51,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00025',
          quantity: 5.61,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00021',
          quantity: 0.14,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00019',
          quantity: 19.69,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1721.17,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'processing',
          emissions_category_id: 'proc_00034',
          quantity: 20.21,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00001',
          quantity: 56.44,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00002',
          quantity: 37.95,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00142',
          quantity: 23.1,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  arable_5yr_baseline: {
    id: 'arable_5yr_baseline',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 7.07,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 2.18,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 2.23,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 20.85,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00018',
          quantity: 11.4,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00025',
          quantity: 4.34,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00021',
          quantity: 0.13,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00019',
          quantity: 16.2,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1699.32,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'processing',
          emissions_category_id: 'proc_00034',
          quantity: 17.2,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00001',
          quantity: 66.4,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00002',
          quantity: 23,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00142',
          quantity: 14,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00136',
          quantity: 17.2,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  arable_3yr_hemp: {
    id: 'arable_3yr_hemp',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 7.19,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 3.03,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 4.42,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 18.72,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00018',
          quantity: 8.43,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00025',
          quantity: 1.65,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00021',
          quantity: 0.09,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00019',
          quantity: 12.43,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1817,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'processing',
          emissions_category_id: 'proc_00034',
          quantity: 11.37,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00001',
          quantity: 56.44,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00002',
          quantity: 37.95,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00182',
          quantity: 49.5,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  arable_5yr_hemp: {
    id: 'arable_5yr_hemp',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 6.49,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 2.69,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 3.59,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 20.74,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00018',
          quantity: 8.32,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00025',
          quantity: 1.94,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00021',
          quantity: 0.1,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00019',
          quantity: 11.8,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1770.2,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'processing',
          emissions_category_id: 'proc_00034',
          quantity: 11.84,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00001',
          quantity: 66.4,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00002',
          quantity: 23,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00136',
          quantity: 17.2,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00182',
          quantity: 30,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  livestock_no_input_cattle: {
    id: 'livestock_no_input_cattle',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1087.44,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/animals-dmi-no-milk',
        inputs: {
          section: 'livestock',
          emissions_category_id: 'live_00006',
          quantity: 24,
          area: null,
          livestock_last_year: 0,
          dry_matter_intake: 0,
          livestock_bought: 0,
          livestock_sold: 0,
          dairy_yield: 0,
          milk_fat_percentage: 0,
          milk_protein_percentage: 0,
          slurry_perc: 0,
          farm_yard_manure_perc: 0,
          in_field_manure_perc: 100,
          spread_perc: 0,
          spreading_grassland: 0,
          spreading_arable: 0,
          animal_weight: 600,
        },
      },
    ],
  },
  livestock_low_input_cattle: {
    id: 'livestock_low_input_cattle',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 2.9,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 0.75,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 2,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1087.44,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/animals-dmi-no-milk',
        inputs: {
          section: 'livestock',
          emissions_category_id: 'live_00006',
          quantity: 24,
          area: null,
          livestock_last_year: 0,
          dry_matter_intake: 0,
          livestock_bought: 0,
          livestock_sold: 0,
          dairy_yield: 0,
          milk_fat_percentage: 0,
          milk_protein_percentage: 0,
          slurry_perc: 0,
          farm_yard_manure_perc: 0,
          in_field_manure_perc: 100,
          spread_perc: 0,
          spreading_grassland: 0,
          spreading_arable: 0,
          animal_weight: 600,
        },
      },
    ],
  },
  livestock_high_input_cattle: {
    id: 'livestock_high_input_cattle',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 5.8,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 0.92,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 2.57,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/animals-dmi-no-milk',
        inputs: {
          section: 'livestock',
          emissions_category_id: 'live_00006',
          quantity: 32,
          area: null,
          livestock_last_year: 0,
          dry_matter_intake: 0,
          livestock_bought: 0,
          livestock_sold: 0,
          dairy_yield: 0,
          milk_fat_percentage: 0,
          milk_protein_percentage: 0,
          slurry_perc: 0,
          farm_yard_manure_perc: 0,
          in_field_manure_perc: 100,
          spread_perc: 0,
          spreading_grassland: 0,
          spreading_arable: 0,
          animal_weight: 600,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1449.92,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  livestock_high_input_silage_cattle: {
    id: 'livestock_high_input_silage_cattle',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 8.7,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 1.17,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 3.2,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/animals-dmi-no-milk',
        inputs: {
          section: 'livestock',
          emissions_category_id: 'live_00006',
          quantity: 40,
          area: null,
          livestock_last_year: 0,
          dry_matter_intake: 0,
          livestock_bought: 0,
          livestock_sold: 0,
          dairy_yield: 0,
          milk_fat_percentage: 0,
          milk_protein_percentage: 0,
          slurry_perc: 0,
          farm_yard_manure_perc: 0,
          in_field_manure_perc: 100,
          spread_perc: 0,
          spreading_grassland: 0,
          spreading_arable: 0,
          animal_weight: 600,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 1812.4,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00086',
          quantity: 800,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  livestock_no_input_sheep: {
    id: 'livestock_no_input_sheep',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/animals-dmi-no-milk',
        inputs: {
          section: 'livestock',
          emissions_category_id: 'live_00015',
          quantity: 225,
          area: null,
          livestock_last_year: 0,
          dry_matter_intake: 0,
          livestock_bought: 0,
          livestock_sold: 0,
          dairy_yield: 0,
          milk_fat_percentage: 0,
          milk_protein_percentage: 0,
          slurry_perc: 0,
          farm_yard_manure_perc: 0,
          in_field_manure_perc: 100,
          spread_perc: 0,
          spreading_grassland: 0,
          spreading_arable: 0,
          animal_weight: 70,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 425.25,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  livestock_low_input_sheep: {
    id: 'livestock_low_input_sheep',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00183',
          quantity: 2.9,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00273',
          quantity: 0.75,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00283',
          quantity: 2,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/animals-dmi-no-milk',
        inputs: {
          section: 'livestock',
          emissions_category_id: 'live_00015',
          quantity: 225,
          area: null,
          livestock_last_year: 0,
          dry_matter_intake: 0,
          livestock_bought: 0,
          livestock_sold: 0,
          dairy_yield: 0,
          milk_fat_percentage: 0,
          milk_protein_percentage: 0,
          slurry_perc: 0,
          farm_yard_manure_perc: 0,
          in_field_manure_perc: 100,
          spread_perc: 0,
          spreading_grassland: 0,
          spreading_arable: 0,
          animal_weight: 70,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 425.25,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_miscanthus_arable: {
    id: 'biomass_miscanthus_arable',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 310.45,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 1.8,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00181',
          quantity: 204,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_switchgrass_arable: {
    id: 'biomass_switchgrass_arable',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 295.9,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 1.8,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00183',
          quantity: 162.4,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_reedcanary_arable: {
    id: 'biomass_reedcanary_arable',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 295.9,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 1.8,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00196',
          quantity: 96,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_SRC_willow_arable: {
    id: 'biomass_SRC_willow_arable',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 273.75,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 3.6,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00179',
          quantity: 72,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_SRC_poplar_arable: {
    id: 'biomass_SRC_poplar_arable',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 273.75,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 3.6,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00180',
          quantity: 72,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_miscanthus_grassland: {
    id: 'biomass_miscanthus_grassland',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 313.59,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 1.8,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00181',
          quantity: 204,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_switchgrass_grassland: {
    id: 'biomass_switchgrass_grassland',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 302.99,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 3.6,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00183',
          quantity: 162.4,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_reedcanary_grassland: {
    id: 'biomass_reedcanary_grassland',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 302.99,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 3.6,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00196',
          quantity: 96,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_SRC_willow_grassland: {
    id: 'biomass_SRC_willow_grassland',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 309.64,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 4.32,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00179',
          quantity: 72,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
  biomass_SRC_poplar_grassland: {
    id: 'biomass_SRC_poplar_grassland',
    inputSets: [
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'fuels',
          emissions_category_id: 'fuel_00016',
          quantity: 309.64,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/default',
        inputs: {
          section: 'inputs',
          emissions_category_id: 'inpu_00020',
          quantity: 4.32,
          area: null,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
      {
        endpoint: '/api/v1/calculation/agri-veg',
        inputs: {
          section: 'crops',
          emissions_category_id: 'crop_00180',
          quantity: 72,
          area: 1,
          livestock_last_year: null,
          dry_matter_intake: null,
          livestock_bought: null,
          livestock_sold: null,
          dairy_yield: null,
          milk_fat_percentage: null,
          milk_protein_percentage: null,
          slurry_perc: null,
          farm_yard_manure_perc: null,
          in_field_manure_perc: null,
          spread_perc: null,
          spreading_grassland: null,
          spreading_arable: null,
          animal_weight: null,
        },
      },
    ],
  },
};
